// extracted by mini-css-extract-plugin
export default {"component":"oI5Y9"};